const o = "_root_c75uf_1", t = {
  root: o
};
export {
  t as default,
  o as root
};
//# sourceMappingURL=index.es749.js.map
